import React from "react";
import PropTypes from "prop-types";
import DescriptionListGroup from '../../common/components/DescriptionListGroup/DescriptionListGroup';

function Component({ className = "", children: items, renderFalsy }) {
  return (
    
    <dl className={`c-description-list c-description-list--grid${className ? ` ${className}` : ''}`}>
      {items
        .filter(item => item && (renderFalsy || !!item.data))
        .map((item, index) => (
          <DescriptionListGroup key={index} termText={item.title} detail={item.data} />
        ))}
    </dl>
  );
}

Component.propTypes = {
  renderFalsy: PropTypes.bool,
};

Component.defaultProps = {
  renderFalsy: true,
};

export { Component as DefinitionList };
